const __WEBPACK_NAMESPACE_OBJECT__ = wp.date;